import get from 'get-object-path';

export default {
    methods: {
        hasGivenPermission(permissionId) {
            return !!_.find(get(this.$store.getters.selectedClub, 'permissions.data'), [
                'permission.data.id',
                permissionId
            ]);
        },

        canViewAthleteProfile() {
            return this.hasGivenPermission('view-athlete-profile');
        },

        canInviteMembers() {
            return this.hasGivenPermission('invite-members');
        },

        canManageLicense() {
            return this.hasGivenPermission('manage-licences');
        },

        canImportDrvFile() {
            return this.hasGivenPermission('drv-import-files');
        },

        canViewDrvProfile() {
            return this.hasGivenPermission('drv-view-personal-details');
        }
    },

    computed: {
        canViewAllMembersErgoProgressReport() {
            return this.hasGivenPermission('view-all-members-on-ergo-progress-report');
        },

        canViewAllMembersWaterProgressReport() {
            return this.hasGivenPermission('view-all-members-on-water-progress-report');
        },

        canViewAllMembersGmtReport() {
            return this.hasGivenPermission('view-all-members-on-gmt-report');
        },

        canViewAllMembersMorningMonitoringReport() {
            return this.hasGivenPermission('view-all-members-on-morning-monitoring-report');
        },

        canViewAllMembersRpeReport() {
            return this.hasGivenPermission('view-all-members-on-rpe-report');
        },

        canViewAllMembersAttendanceReport() {
            return this.hasGivenPermission('view-all-members-on-attendance-report');
        },

        canViewAllMembersTrainingSummaryReport() {
            return this.hasGivenPermission('view-all-members-on-training-summary-report');
        },

        canViewAllSessions() {
            return this.hasGivenPermission('view-all-sessions');
        },

        canCreateSquads() {
            return this.hasGivenPermission('create-squads');
        },

        canEditSquads() {
            return this.hasGivenPermission('edit-squads');
        },

        canDeleteSquads() {
            return this.hasGivenPermission('delete-squads');
        },

        canViewClubMembers() {
            return this.hasGivenPermission('manage-members');
        },

        canViewAllMembersStepTest() {
            return this.hasGivenPermission('drv-view-all-members-on-step-test-report');
        },

        canViewAllMembersVo2Test() {
            return this.hasGivenPermission('drv-view-all-members-on-vo2-test-report');
        },

        canViewAllMembers2kTest() {
            return this.hasGivenPermission('drv-view-all-members-on-2k-test-report');
        },

        canViewAllMembers6kTest() {
            return this.hasGivenPermission('drv-view-all-members-on-6k-test-report');
        },

        canViewManageInventory() {
            return this.hasGivenPermission('manage-inventory');
        }
    }
};
